<template>
	<div class="container page">
		<div class="header">
			<van-nav-bar :title="$t('other.deposit_history')" class="nav-bar">
				<template #left>
					<van-icon name="arrow-left" color="#fff" @click="back()" />
				</template>
			</van-nav-bar>
		</div>
		<div class="main">
			<van-empty v-if="list.length === 0" :description="$t('withdraw.empty_data')" />
			<div v-else class="item_list" v-for="(v,key) in list" :key="key">
				<div class="topInfo">
					<span>{{$t("withdraw.money")}}：{{v.amount}}</span>
				</div>
				<div class="desc">
					<span>{{$t("Số thứ tự")}}：{{v.order_sn}}</span>
				</div>
				<div class="time">
					<span>{{$t("withdraw.submit_time")}}：{{v.createtime_text}}</span>
				</div>
				<div class="time">
					<span>{{$t("withdraw.desc")}}：{{v.reason}}</span>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	export default {
		data() {
			return {
				isLoading: false,
				list: []
			};
		},
		created() {
			this.getUserWithdrawList();
		},
		methods: {
			back() {
				return window.history.back();
			},
			getUserWithdrawList() {
				this.$http({
					method: 'get',
					url: 'getRechargeList',
					data: {
						page: 1,
						limit: 99999,
					}
				}).then(res => {
					if (res.code === 1) {
						console.log(res.data)
						this.list = res.data;
					} else {
						this.$toast(res.msg);
					}
				})
			}
		},

	};
</script>

<style lang='less' scoped>
	@import "../../assets/css/base.css";

	.nav-bar {
		background: linear-gradient(90deg, #f905e5, #e6c3a1);
	}

	::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
		color: #000000;
		font-size: 35px;
	}

	::v-deep .van-loading__text {
		color: #000000;
		font-size: 35px;
	}

	.container .main {
		position: relative;
		background-color: #f2f2f5;
		height: 100%;
		padding: 0 10px;
	}

	.item_list {
		padding: 15px 15px;
		margin: 30px 10px;
		background: #fff;
		border-radius: 10px;
		line-height: 60px;
	}

	.item_list .topInfo span {
		flex: 1;
		font-size: 30px;
		font-weight: 700;
		color: #ff253f;
	}

	.item_list .time span {
		flex: 1;
		font-size: 25px;
		font-weight: 500;
		color: #000;
	}

	.item_list .topInfo span:last-child {
		float: right;
	}

	.item_list .desc span {
		font-size: 25px;
		font-weight: 700;
		color: #9b9b9b;
	}
</style>